module.exports = __webpack_public_path__ + "img/history_btn.bc97ded5.png";